import { mapGetters, mapActions, mapMutations } from 'vuex';
import ShortCodeSearchService from "shared/services/shortCodeSearch.service";
import * as _ from 'lodash';
import { prepareSearchPhrase } from 'shared/utils/queryParams.utils';

export default {
	data: function () {
		return {
			searchField: {},
		};
	},
	props: {
		shortCodeApiUri: {
			type: String,
			required: true
		},
	},
	computed: {
		...mapGetters({
			globalSearchModel: 'getGlobalSearchModel',
			globalAutoSuggestSearchResults: 'getGlobalAutoSuggestSearchResults',
			noAutocompleteItems: 'getNoAutocompleteItems',
			isSearchPage: 'getIsSearchPage',
			language: 'getCulture',
			selectedSuggestionIndex: 'getSelectedSuggestionIndex',
		}),
		searchPageUrl() {
			if (!_.isEmpty(this.globalSearchModel) && this.globalSearchModel.SearchResultPageUrl)
				return this.globalSearchModel.SearchResultPageUrl;
			else
				return '';
		},
		startAutocompleteSearch() {
			return this.localSearchPhrase.length >= this.globalSearchModel.AutoSuggestionMinimumCharacters;
		},
		searchAutocompleteResultsVisible() {
			return this.localSearchPhrase.length > 0 && this.globalAutoSuggestSearchResults?.length > 0 || !!this.noAutocompleteItems;
		},
		localSearchPhrase() {
			if (this.searchField) {
				return this.$refs.searchField?.localSeachPhrase || '';
			}
			else {
				return '';
			}
		},
		isFirstAutoSuggestCardFocused(){
			return this.selectedSuggestionIndex == 0
		},
		isLastAutoSuggestCardFocused() {
			return this.selectedSuggestionIndex == this.globalAutoSuggestSearchResults.length - 1 && this.globalAutoSuggestSearchResults.length != 0
		}
	},
	created() {
		//to cancel and clear autosuggestions if it is clicked outside
		window.addEventListener('click', (e) => {
			if (!this.$el.contains(e.target)) {
				this.cancelAutosuggestionSearch();
			}
		})
	},
	beforeDestroy() {
		document.removeEventListener('click');
	},

	mounted() {
		this.$nextTick(() => {
			this.searchField = this.$refs.searchField;
		})
	},
	watch: {
		searchAutocompleteResultsVisible: {
			immediate: true,
			deep: true,
			handler(newVal) {
				if (newVal) {
					document.body.style.overflow = 'hidden';
				}
				else {
					document.body.removeAttribute('style');
				}
			}
		}
	},
	methods: {
		...mapActions([
			'autoSuggestGlobalSearch',
			'cancelAutosuggestionSearch',
		]),
		...mapMutations([
			'setSelectedSuggestionIndex'
		]),
		autoSuggestSearch() {
			if (this.startAutocompleteSearch) {
				this.autoSuggestGlobalSearch({ searchPhrase: this.localSearchPhrase, language: this.language });
			}
		},

		/**
		 * Make sure not to assign it directly as event handler
		 * for event that emits general search phrase.
		 * It would treat search phrase as "facet" parameter
		 * resulting in not finding results.
		 *
		 * @example
		 * // DON'T
		 * v-on:search="executeSearch"
		 *
		 * // DO
		 * v-on:search="handleSearch"
		 * handleSearch: () => {
		 * 	this.executeSearch();
		 * }
		 */
		async executeSearch(facet = null) {
			const searchPhrase = this.localSearchPhrase.trim();

			// not for the search page field

			// first do short code search
			const shortCodeRegex = /^[A-Za-z0-9]{4,6}$/;

			if (shortCodeRegex.test(searchPhrase)) {
				const response = await this.shortCodeSearch(searchPhrase);

				// if no result from short code search, do keyword search
				if (!response?.data?.items?.length && !facet) {
					window.location.assign(`${this.searchPageUrl}?q=${searchPhrase}`);
				} else if (!response?.data?.items?.length && facet) {
					window.location.assign(`${this.searchPageUrl}?q=${searchPhrase}&fc=${facet}`);
				}
			} else if (searchPhrase.length && !facet) {
				window.location.assign(`${this.searchPageUrl}?q=${prepareSearchPhrase(searchPhrase)}`);
			} else if (searchPhrase.length && facet) {
				window.location.assign(`${this.searchPageUrl}?q=${prepareSearchPhrase(searchPhrase)}&fc=${facet}`);
			}
		},

		shortCodeSearch(phrase) {
			const response = ShortCodeSearchService.getShortCode(`${this.shortCodeApiUri}${phrase}`);

			response.then(({data}) => {
				if (data?.items?.length > 0) {
					location.href = `${location.protocol}//${location.host}${data.items[0].url}`;
				}
			})

			return response;
		},

		handleDescSuggestion() {
			if (this.isFirstAutoSuggestCardFocused) {
				this.setSearchInputFocus();
				this.setSelectedSuggestionIndex("reset");
			} else {
				this.setSelectedSuggestionIndex("desc");
			}
		},
		handleAscSuggestion() {
			if ( !this.isLastAutoSuggestCardFocused ) {
				this.setSelectedSuggestionIndex("asc");
			}
		},

		setSearchInputFocus() {
			let inputRef = this.isSearchPage ? this.$refs.searchField.$el : this.$refs.GlobalSearchPopup;
			const searchField = inputRef.querySelector('.c-global-search__field');
			if (searchField != null) {
				this.$nextTick(() => {
					searchField.focus();
				});
			}
		}
	}
}
